// Firm kind on the client (owner 2026-10-03: never guess a firm's type from its NAME). The server sends
// each firm's `kind` (companies.firm_kind: 'legal' / 'accounting' / both, '' = neither) with every firm
// list (companyScope.firmsFor, taken_return firms). The two words below are product vocabulary — the
// kinds a firm can have — not any tenant's name.
import { useStore } from '../store';

export type FirmLike = { name?: string; short?: string; kind?: string; firm_kind?: string } | null | undefined;
export const firmKindOf = (f: FirmLike): string => String(f?.kind ?? f?.firm_kind ?? '').toLowerCase();
export const isLegalFirm = (f: FirmLike): boolean => /\blegal\b/.test(firmKindOf(f));
export const isAccountingFirm = (f: FirmLike): boolean => /\baccounting\b/.test(firmKindOf(f));
/** The chip / tab word: 'Legal' / 'Accounting' by kind, else the firm's short name (else name). */
export const firmTabLabel = (f: FirmLike): string =>
  isLegalFirm(f) ? 'Legal' : isAccountingFirm(f) ? 'Accounting' : String(f?.short || f?.name || '');

/** Which firms a stored firm-label tag names (contacts.source_label: one label, or a comma-joined pair),
 *  compared with the firms' current labels from /api/me (firmSettings.firmLabel) — never by a word in the name. */
export function labelKinds(label: string | null | undefined): { legal: boolean; accounting: boolean } {
  const fl = useStore.getState().me?.firmLabels || { legal: '', accounting: '' };
  const parts = String(label || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  const has = (l: string) => !!l.trim() && parts.includes(l.trim().toLowerCase());
  return { legal: has(fl.legal || ''), accounting: has(fl.accounting || '') };
}
